// 0-4: longitud, mayúscula+minúscula, número, símbolo — cada uno suma un punto,
// con un punto extra por longitud >=12 (contraseñas largas son las que más
// pesan en la resistencia real contra fuerza bruta).
export function scorePassword(password) {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  return Math.min(score, 4);
}

const LEVELS = [
  { label: 'Muy débil', color: 'bg-red-500', text: 'text-red-400' },
  { label: 'Débil', color: 'bg-red-500', text: 'text-red-400' },
  { label: 'Regular', color: 'bg-amber-500', text: 'text-amber-400' },
  { label: 'Buena', color: 'bg-amber-500', text: 'text-amber-400' },
  { label: 'Fuerte', color: 'bg-emerald-500', text: 'text-emerald-400' },
];

export default function PasswordStrengthMeter({ password }) {
  if (!password) return null;
  const score = scorePassword(password);
  const level = LEVELS[score];
  return (
    <div className="space-y-1">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`h-1 flex-1 rounded-full ${i < score ? level.color : 'bg-border'}`} />
        ))}
      </div>
      <p className={`text-xs ${level.text}`}>{level.label}</p>
    </div>
  );
}
